<template>
  
  <div class="menu">
    <slot></slot>
  </div>
  
</template>

<script>
export default {

}
</script>

<style>

/* Button that TING made */
  .menu{
    z-index: 1000;
    position: fixed;
    top:85%;
    left:2%;
    font-family: 'HNI', Helvetica, Arial, sans-serif;
    display:flex;
    flex-direction: column;
    /* color: white; */
  }



</style>